import { render, staticRenderFns } from "./SanimpresaTooltip.vue?vue&type=template&id=f19a5892"
import script from "./SanimpresaTooltip.vue?vue&type=script&lang=js"
export * from "./SanimpresaTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports